import { useMutation } from 'query';
import { getFile } from '../../services';

type FileDownloadParameters = {
  url: string;
};

export const useGetFileMutation = () =>
  useMutation<Blob, FileDownloadParameters>({
    async mutationFn({ url }) {
      const { data } = await getFile({ routeParams: { url } });

      return data;
    },
  });
